export const es = {
    'ROLE_FILTER.LABEL': 'Filtrar roles',
    'ROLE_FILTER.SHOW_ALL': 'Mostrar todos los roles',
    'ROLE_FILTER.ELEVATED': 'Roles elevados',
    'ROLE_FILTER.ROLE_COUNT': '{[{ count }]} roles',
    'ROLE_FILTER.SELECT_ALL': 'Seleccionar todos los roles',
    'ROLE_FILTER.SELECT_ELEVATED': 'Seleccionar roles elevados',
    'ROLE_FILTER.CLEAR': 'Borrar selección',
    'ROLES.ADMIN': 'Administrador',
    'ROLES.REPORTER': 'Reportero',
    'ROLES.VR_USER': 'Usuario VR',
    'ROLES.EVENT_MANAGER': 'Gestor de eventos',
    'ROLES.EVENT_CURATOR': 'Comisario de eventos',
    'ROLES.BC_USER': 'Usuario BC',
    'ROLES.BC_MANAGER': 'Gestor BC',
    'ROLES.DA_USER': 'Usuario DA',
    'ROLES.DA_MANAGER': 'Gestor DA',
    'ROLES.LR_USER': 'Usuario LR',
};
